import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { AppPropertiesConfigService } from 'src/app/services/app-properties-config.service';

@Component({
  selector: 'app-app-properties-config-list',
  templateUrl: './app-properties-config-list.component.html',
  styleUrls: ['./app-properties-config-list.component.css']
})
export class AppPropertiesConfigListComponent implements OnInit {

  appPropertiesConfigList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading: any = false;
  id: any;
  cid: any;
  formSubmit: boolean = false;
  isEdit: boolean = false;
  singleData: any = [];

  appPropertiesConfigForm!: FormGroup;
  appPropertiesConfigUpdateForm!: FormGroup;

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };

  searchFilter: any = "";
  recordName: any = "";
  recordId: any = "";

  constructor(private generic_service: GenericService,
    private app_properties_config_service: AppPropertiesConfigService, 
    private fb: FormBuilder, 
    private toastr: ToastrService) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/');
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1]);
    this.actionControls = action;

    this.cid = Number(sessionStorage.getItem('cid'));

    this.appPropertiesConfigForm = this.fb.group({
      description: ['', [Validators.required]],
      clientId: ['', [Validators.required]],
      key: ['', [Validators.required]],
      value: ['', [Validators.required]],
      qrCodeImageLink: ['']
    });

    this.appPropertiesConfigUpdateForm = this.fb.group({
      description: ['', [Validators.required]],
      clientId: ['', [Validators.required]],
      key: ['', [Validators.required]],
      value: ['', [Validators.required]],
      qrCodeImageLink: ['']
    });

    this.getAllAppPropertiesConfig();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  getAllAppPropertiesConfig() {
    this.isLoading = true;
    this.app_properties_config_service.getAllAppPropertiesConfig().subscribe(
      (res: any) => {
        this.appPropertiesConfigList = res.response || [];
        this.totalRecords = this.appPropertiesConfigList.length;
        this.isLoading = false;
      },
      (err: any) => {
        this.isLoading = false;
        console.log(err);
      }
    )
  }

  getAppPropertiesConfigById(appPropertiesConfigId: any) {
    this.app_properties_config_service.getAppPropertiesConfigById(appPropertiesConfigId).subscribe(
      (response: any) => {
        this.singleData = [];
        this.singleData.push(response.response);
        this.appPropertiesConfigUpdateForm.patchValue({
          description: response.response.description,
          clientId: response.response.clientId,
          key: response.response.key,
          value: response.response.value,
          qrCodeImageLink: response.response.qrCodeImageLink
        });
        this.isEdit = true;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  viewAppPropertiesConfigById(appPropertiesConfigId: any) {
    this.app_properties_config_service.getAppPropertiesConfigById(appPropertiesConfigId).subscribe(
      (response: any) => {
        this.singleData = [];
        this.singleData.push(response.response);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click();
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
  }

  deleteAppPropertiesConfig() {
    this.app_properties_config_service.deleteAppPropertiesConfig(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllAppPropertiesConfig();
        this.cancelModel();
        this.clearData();
      },
      (error: any) => {
        this.toastr.error(error.error?.errors?.[0]?.description || "Error deleting record");
      }
    )
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.id;
    this.recordName = list.key;
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  closePopUp() {
    this.recordId = "";
    this.recordName = "";
    this.appPropertiesConfigForm.reset();
    this.appPropertiesConfigUpdateForm.reset();
    this.formSubmit = false;
  }

  addAppPropertiesConfig() {
    if (this.formSubmit) {
      return;
    }
    this.formSubmit = true;
    if (!this.appPropertiesConfigForm.valid) {
      this.formSubmit = false;
      this.toastr.error("Please fill required fields");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.appPropertiesConfigForm.get('description')?.value,
      "clientId": this.appPropertiesConfigForm.get('clientId')?.value,
      "key": this.appPropertiesConfigForm.get('key')?.value,
      "value": this.appPropertiesConfigForm.get('value')?.value,
      "qrCodeImageLink": this.appPropertiesConfigForm.get('qrCodeImageLink')?.value,
      "status": 0,
      "cid": this.cid
    }

    this.app_properties_config_service.addAppPropertiesConfig(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.appPropertiesConfigForm.reset();
        this.cancelModel();
        this.getAllAppPropertiesConfig();
        this.toastr.success(response.message);
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding record");
      }
    )
  }

  updateAppPropertiesConfig() {
    if (this.formSubmit) {
      return;
    }
    this.formSubmit = true;
    if (!this.appPropertiesConfigUpdateForm.valid) {
      this.formSubmit = false;
      this.toastr.error("Please fill required fields");
      return;
    }

    let body = {
      "version": this.singleData[0].version || 0,
      "isActive": this.singleData[0].isActive,
      "description": this.appPropertiesConfigUpdateForm.get('description')?.value,
      "id": this.singleData[0].id,
      "clientId": this.appPropertiesConfigUpdateForm.get('clientId')?.value,
      "key": this.appPropertiesConfigUpdateForm.get('key')?.value,
      "value": this.appPropertiesConfigUpdateForm.get('value')?.value,
      "qrCodeImageLink": this.appPropertiesConfigUpdateForm.get('qrCodeImageLink')?.value,
      "status": this.singleData[0].status || 0,
      "cid": this.cid
    }

    this.app_properties_config_service.updateAppPropertiesConfig(body).subscribe(
      (response: any) => {
        this.isEdit = false;
        this.getAllAppPropertiesConfig();
        this.cancelModel();
        this.formSubmit = false;
        this.appPropertiesConfigUpdateForm.reset();
        this.toastr.success(response.message);
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error updating record");
      },
    )
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllAppPropertiesConfig();
  }

  getAppPropertiesConfigByWildSearch() {
    if (this.searchFilter == "" || this.searchFilter == null) {
      return;
    }
    this.app_properties_config_service.getAppPropertiesConfigByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.appPropertiesConfigList = [];
          this.totalRecords = 0;
          return;
        }
        this.appPropertiesConfigList = res.response;
        this.totalRecords = res.response.length;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
}
